import React, { useState, useRef } from 'react';
import { withTranslation } from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import './TipsModal.scss';

const TipsModal = ({ closeModal, orderPaymentsSum, onSubmit, onClose, t }) => {
  const [calcInputValue, setCalcInputValue] = useState('');

  const paymentInput = useRef(null);

  const onClickKeyBoardBtn = (e) => {
    const { value, name } = e.currentTarget;

    let computedSumm = null;

    if (name === 'clear') {
      computedSumm = '0';
    } else if (name === 'percent') {
      const summ = `${orderPaymentsSum / 100}*${value}`;
      computedSumm = eval(summ);
      computedSumm = parseFloat(computedSumm).toFixed(2);
    }

    setCalcInputValue(computedSumm);
  }
  const onClickKeyBoardInput = () => {
    setCalcInputValue('');
  }

  const onClickKeyBoardInputChange = (e) => {
    const { value, name } = e.currentTarget;
    const reg = /^\d{0,8}.\d{0,2}?$/;

    let computedSumm = null;
    if (name === 'keyboard') {
      computedSumm = `${calcInputValue}${value}`;
    } else if (name === 'minus') {
      computedSumm = calcInputValue.slice(0, -1);
    } else {
      computedSumm = value.toString();
    }

    if (computedSumm === '') {
      setCalcInputValue('');
      return;
    }

    if (!reg.test(computedSumm)) {
      return;
    }

    setCalcInputValue(computedSumm);
  }

  const onSubmitTips = (e) => {
    e.preventDefault();
    onSubmit(parseInt(calcInputValue ? calcInputValue * 100 : 0 , 10));
    closeModal();
  }

  const onCancelTips = (e) => {
    e.preventDefault();
    onClose();
    closeModal();
  }

  const clearInput = () => {
    setCalcInputValue('');
    paymentInput.current.focus();
  }

  return (
    <div className="tips-modal-container">
      <div className="title">{t("tips_modal.title")}</div>
      <div className="content">
        {/* <form onSubmit={onSubmitTips}> */}
          <div className="tips-container">
            <div className="tips-form-wrapper">
              <div className="display-wrapper">
                <input
                  ref={paymentInput}
                  type="text"
                  name="order_payments_sum"
                  className="display-input"
                  id="order-payments-sum"
                  placeholder="₪ 0.00"
                  readOnly
                  value={calcInputValue}
                  onChange={onClickKeyBoardInputChange}
                  onFocus={onClickKeyBoardInput}
                />
                {calcInputValue.length > 0 && (
                  <span className="clear-display" onClick={clearInput}>
                    <FontAwesomeIcon icon="times-circle" />
                  </span>
                )}
              </div>
              <div className="keyboard-content">
                <div className="keyboard-digits-wrapper">
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="1"
                    onClick={onClickKeyBoardInputChange}
                  >
                    1
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="2"
                    onClick={onClickKeyBoardInputChange}
                  >
                    2
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="3"
                    onClick={onClickKeyBoardInputChange}
                  >
                    3
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="4"
                    onClick={onClickKeyBoardInputChange}
                  >
                    4
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="5"
                    onClick={onClickKeyBoardInputChange}
                  >
                    5
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="6"
                    onClick={onClickKeyBoardInputChange}
                  >
                    6
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="7"
                    onClick={onClickKeyBoardInputChange}
                  >
                    7
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="8"
                    onClick={onClickKeyBoardInputChange}
                  >
                    8
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="9"
                    onClick={onClickKeyBoardInputChange}
                  >
                    9
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="."
                    onClick={onClickKeyBoardInputChange}
                  >
                    .
                  </button>
                  <button
                    type="button"
                    name="keyboard"
                    className="keyboard-digit-btn"
                    value="0"
                    onClick={onClickKeyBoardInputChange}
                  >
                    0
                  </button>
                  <button
                    type="button"
                    name="minus"
                    className="keyboard-digit-btn"
                    value="-"
                    onClick={onClickKeyBoardInputChange}
                  >
                    <FontAwesomeIcon icon="angle-left" />
                  </button>
                </div>

                <div className="percent-buttons-wrapper">
                  <button
                    type="button"
                    name="percent"
                    className="keyboard-digit-btn"
                    value="0.1"
                    onClick={onClickKeyBoardBtn}
                  >
                    10%
                  </button>
                  <button
                    type="button"
                    name="percent"
                    className="keyboard-digit-btn"
                    value="0.12"
                    onClick={onClickKeyBoardBtn}
                  >
                    12%
                  </button>
                  <button
                    type="button"
                    name="percent"
                    className="keyboard-digit-btn"
                    value="0.13"
                    onClick={onClickKeyBoardBtn}
                  >
                    13%
                  </button>
                  <button
                    type="button"
                    name="percent"
                    className="keyboard-digit-btn"
                    value="0.15"
                    onClick={onClickKeyBoardBtn}
                  >
                    15%
                  </button>
                  <button
                    type="button"
                    name="percent"
                    className="keyboard-digit-btn"
                    value="0.17"
                    onClick={onClickKeyBoardBtn}
                  >
                    17%
                  </button>
                  <button
                    type="button"
                    name="percent"
                    className="keyboard-digit-btn"
                    value="0.2"
                    onClick={onClickKeyBoardBtn}
                  >
                    20%
                  </button>
                </div>
              </div>
            </div>
            <div className="action-buttons">
              <button
                type="submit"
                className="btn btn-primary am-button am-button-primary am-button-inline"
                onClick={onSubmitTips}
              >
                {t("buttons.ok_tips")}
              </button>
              <button className="btn btn-back" onClick={onCancelTips}>
                {t("buttons.cancel_tips")}
              </button>
            </div>
          </div>
        {/* </form>*/}
      </div>
    </div>
  );
};

export default withTranslation()(TipsModal);
